"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerListItemMore = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const MoreIcon_1 = require("../../../assets/icons/MoreIcon");
const MoreRightIcon_1 = require("../../../assets/icons/MoreRightIcon");
const DrawerListItem_1 = require("../drawerListItem/DrawerListItem");
const Styled = __importStar(require("./DrawerListItemMore.styles"));
const ListItemStyled = __importStar(require("../drawerListItem/DrawerListItem.styles"));
const DrawerListItemMore = ({ routes, title, open, onClickRoute }) => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const isMatchingAnyRoute = routes.some((route) => !!(0, react_router_dom_1.matchPath)({ end: true, path: route.to }, pathname));
    const isPopoverOpen = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const active = isMatchingAnyRoute || isPopoverOpen;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Styled.ListItem, { disableRipple: true, button: true, "$active": active, onClick: handleClick, children: [(0, jsx_runtime_1.jsx)(ListItemStyled.Icon, { "$isOpen": open, children: (0, jsx_runtime_1.jsx)(MoreIcon_1.MoreIcon, { active: active }) }), (0, jsx_runtime_1.jsxs)(ListItemStyled.TextWrapper, { "$isOpen": open, children: [(0, jsx_runtime_1.jsx)(ListItemStyled.ListItemText, { "$isOpen": open, children: title }), (0, jsx_runtime_1.jsx)(Styled.MoreRightIconWrapper, { children: (0, jsx_runtime_1.jsx)(MoreRightIcon_1.MoreRightIcon, { active: active }) })] })] }), (0, jsx_runtime_1.jsx)(Styled.Popover, { anchorEl: anchorEl, open: isPopoverOpen, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, children: (0, jsx_runtime_1.jsx)(Styled.PopoverBody, { children: routes.map((route) => ((0, jsx_runtime_1.jsx)(DrawerListItem_1.DrawerListItem, { icon: route.icon, activeIcon: route.activeIcon, to: route.to, title: route.title, open: true, onClickRoute: onClickRoute }, route.to))) }) })] }));
};
exports.DrawerListItemMore = DrawerListItemMore;
